import { useEffect, useState } from 'react';

const DEFAULT_DELAY_MS = 1000;

export const useDelayedLoading = (isLoading: boolean, delay = DEFAULT_DELAY_MS): boolean => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		if (!isLoading) {
			setIsVisible(false);
			return;
		}

		const timeoutId = setTimeout(() => {
			setIsVisible(true);
		}, delay);

		return () => {
			clearTimeout(timeoutId);
		};
	}, [delay, isLoading]);

	return isVisible;
};
